import React, { useEffect, useState } from 'react';
import useMedia from "use-media";
import golf from "../../../resources/RTCC/icons/golf.svg";
import common from "../../../resources/RTCC/js/common/common";
import './../../../resources/RTCC/css/top/top.css';

export const TopMenuList = (props) => {

    const [dispSwitch, setDispSwitch] = useState([]);

    //レスポンシブ対応
    const useMediaFlag = useMedia({ maxWidth: '960px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);

    useEffect(() => {
        setDispSwitch(props.data);
    }, [props.data]);

    // ボタン押下時
    const onClickTopMenu = (id) => {
        common.scrollWindow(id);
        let dispList = [];
        dispSwitch.map((data) => {
            if (data.idName === id) {
                data.switchflg = true;
            } else {
                data.switchflg = false;
            }
            dispList.push(data);
        })
        setDispSwitch(dispList);
        return;
    }

    return (
        <div className="TopMenuListWrap">
            <div className={isMobilePhone ? "TopMenuListMobile" : "TopMenuList"}>
                {
                    dispSwitch.map((data) => {
                        return (
                            <button className={data.switchflg ? "TopMenuButtonOn" : "TopMenuButtonOff"} onClick={() => onClickTopMenu(data.idName)}>
                                <div className={isMobilePhone ? "TopMenuButtonWrapMobile" : "TopMenuButtonWrap"}>
                                    <img src={`${data.menuUrl} `} className={isMobilePhone ? "TopMenuImgMobile" : "TopMenuImg"} alt={data.topContentAlt} />
                                    <p className={isMobilePhone ? "TopMenuTextMobile" : "TopMenuText"}>{data.topContentAlt}</p>
                                </div>
                            </button>
                        )
                    })
                }
            </div>
        </div>
    );

}